export default {
  maxNum: 80, // 最大缓存数量
  clearTime: 0, // 上次清理时间
  interval: 7200, // 缓存时间 单位 秒
  /**
   * @method: 新增缓存
   * @param {type} 
   * @return: 
   * @Author: 陈长吉（chencj@yunjiglobal.com）
   * @Date: 2019-10-15 10:04:56
   */
  addCache({ id, formId, data }) {
    const cacheName = `${id}${formId}`
    let cacheData = this.getCacheData('cacheData') || {}
    // 前出后进，超过最大数量时 删除最优先缓存的数据
    this.clearMaxNum(cacheData)
    // 存入时间
    cacheData[cacheName] = new Date().getTime() + 3600 * 1000
    localStorage.setItem('cacheData', JSON.stringify(cacheData))
    // 存入数据
    localStorage.setItem(cacheName, JSON.stringify(data))
    // // 执行接口数据缓存
    // this.cacheData[cacheName] = {
    //   data: JSON.stringify(data),
    //   date: new Date().getTime() + 3600 * 1000 // 缓存60分钟
    // }
  },
  /**
   * @method: 外部执行的针对ID删除缓存
   * @param {type} 
   * @return: 
   * @Author: 陈长吉（chencj@yunjiglobal.com）
   * @Date: 2019-10-15 10:05:04
   */
  removeCache({ id, formId }) {
    const cacheName = `${id}${formId}`
    // 获取时间缓存数据
    const cacheData = this.getCacheData('cacheData') || {}
    // 删除时间缓存
    delete cacheData[cacheName]
    // 存回缓存
    localStorage.setItem('cacheData', JSON.stringify(cacheData))
    // 删除数据缓存
    this.removeCacheData(cacheName)
  },
  /**
   * @method: 删除缓存数据
   * @param {type} 
   * @return: 
   * @Author: 陈长吉（chencj@yunjiglobal.com）
   * @Date: 2019-10-15 10:05:04
   */
  removeCacheData(cacheName) {
    localStorage.removeItem(cacheName)
  },
  /**
   * @method: 查询缓存
   * @param {type} 
   * @return: 
   * @Author: 陈长吉（chencj@yunjiglobal.com）
   * @Date: 2019-10-15 10:05:11
   */
  queryCache({ id, formId }) {
    const cacheName = `${id}${formId}`
    const cacheData = this.getCacheData('cacheData') || {}
    // 判断缓存是否过期
    if (cacheData[cacheName] && cacheData[cacheName] > new Date().getTime()) {
      return this.getCacheData(cacheName)
    }
    return false
  },
  /**
   * @method: HTTP 清理过期缓存 固定一个间隔时间清理过期缓存 默认30秒清理一次
   * @param interval {number} 清理缓存数据间隔时间
   * @return: 缓存数据
   * @Author: 陈长吉（chencj@yunjiglobal.com）
   * @Date: 2019-10-15 10:13:44
   */
  clearCache(interval = 60) {
    const nowDate = new Date().getTime()
    const cacheData = this.getCacheData('cacheData') || {}
    let hasHandler = false
    // 判断缓存间隔清理时间
    if (this.clearTime + interval * 1000 < nowDate) {
      this.clearTime = nowDate
      Object.keys(cacheData).forEach((item) => {
        if (cacheData[item] < nowDate) {
          hasHandler = true
          // 删除时间记录值
          delete cacheData[item]
          // 清空缓存数据
          this.removeCacheData(item)
        }
      })
      // 执行清理过期缓存数据
      this.clearCache(this.interval)
      // 最大数量限制
      cacheData = this.clearMaxNum(cacheData)
    }
    if (hasHandler) {
      localStorage.setItem('cacheData', JSON.stringify(cacheData))
    }
  },
  /**
   * @Date: 2019-11-04 15:45:15
   * @method: 获取缓存时间数据
   * @param {type} 
   * @return: 
   * @Author: 陈长吉（chencj@yunjiglobal.com）
   */
  getCacheData(name) {
    try {
      return JSON.parse(localStorage.getItem(name))
    } catch (error) {
      return undefined
    }
  },
  clearMaxNum(cacheData) {
    const list = Object.keys(cacheData)
    if (list.length >= this.maxNum) {
      // 删除的数量
      const num = this.maxNum - list.length + 1
      // 按照时间排序
      list.sort((a, b) => cacheData[a] - cacheData[b])
      // 执行删除，可能多个
      for (let i = 0; i < Math.abs(num); i += 1) {
        const removeKey = list[i]
        // 删除时间记录值
        delete cacheData[removeKey]
        // 清空缓存数据
        this.removeCacheData(removeKey)
      }
    }
    return cacheData
  }
}
